export default __webpack_public_path__ + "static/media/gallery_10.dac3d04d.jpg";